/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Modal from "~components/Modal";

import "./style.scss";
import { useNavigate } from "react-router-dom";
import Select from "~components/Form/components/Select";
import useClientes from "~/fetchs/useClientes";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";

const PricesTableSolicitarNegociacaoModal = ({ isOpen, closeModal, dadosHeader, filters }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      larger={true}
      sub={<Content dadosHeader={dadosHeader} filters={filters} />}
      hideButtonTwo={true}
      hideButtonOne={true}
    />
  );
};

PricesTableSolicitarNegociacaoModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  dadosHeader: PropTypes.object,
  filters: PropTypes.object,
};

const Content = ({ dadosHeader, filters }) => {
  useEffect(() => {
    if (dadosHeader?.clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate("/tabela-preco/" + dadosHeader?.clienteId + "/" + dadosHeader.origem + "-negociacao");
    }
  }, [dadosHeader]);

  const navigate = useNavigate();

  const [value, setValue] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
    navigate("/tabela-preco/" + value + "/nova-negociacao");
  };

  const formikRef = useRef();
  const [microrregiao, setMicrorregiao] = useState(Number(filters?.microrregiao) || 0);

  useEffect(() => {
    setMicrorregiao(Number(filters?.microrregiao) || 0);
  }, [filters]);

  const { handleSearch, options } = useClientes({
    formikRef,
    type: "options",
    campo: "simulador",
    enabledRequest: false,
    microrregiao: microrregiao,
  });
  return (
    <main className="prices-table-modal-solicitar-negociacao">
      <h1 className="title">Selecione o cliente que deseja solicitar negociação:</h1>

      <form className="form" onSubmit={handleSubmit}>
        <div className="min-w-[300px]">
          <Select
            inputName="status"
            className="w-full"
            placeholder="Cliente"
            options={options}
            onInputChange={handleSearch}
            spacingControl={true}
            onChange={(e) => setValue(e.value)}
          />
        </div>

        <button type="submit" className="submit-button-select">
          Enviar
        </button>
      </form>
    </main>
  );
};

Content.propTypes = {
  dadosHeader: PropTypes.object,
  filters: PropTypes.object,
};

export default PricesTableSolicitarNegociacaoModal;
